export default __webpack_public_path__ + "static/media/mode-23.3ea970d8.svg";